<template>
    <v-app id="inspire" style="background-color: #e6e6e6;">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>

                    <v-flex xs12 sm8 md4>

                        <v-card class="elevation-12">

                            <v-toolbar color="#004d40" dark flat>
                                <v-toolbar-title>

                                    <v-row style="width: 500px;">

                                        <div style="margin-left: 10px; width: 50px; height: 50px;">

                                            <img
                                                    style="max-width: 100%; max-height: 100%;"
                                                    src="../assets/Prova.png"
                                            />

                                        </div>

                                        <div><h3 style="width: 250px; margin-top: 10px; margin-left: 10px;">
                                            Aprovação Brasil
                                        </h3></div>

                                    </v-row>

                                    <v-spacer></v-spacer>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-form ref="formLogin" v-model="valid">
                                    <v-text-field
                                            @keydown.enter="doLogin()"
                                            v-model="user.login"
                                            label="Login"
                                            name="login"
                                            prepend-icon="person"
                                            type="text"
                                            :rules="[() => !!user.login || 'Campo obrigatório!']"
                                    ></v-text-field>

                                    <v-text-field
                                            id="password"
                                            :append-icon=" showAppendSenha ? 'mdi-eye' : 'mdi-eye-off'"
                                            label="Senha"
                                            name="password"
                                            prepend-icon="lock"
                                            :type=" showAppendSenha ? 'text' : 'password'"
                                            :rules="[() => !!user.senha || 'Campo obrigatório!']"
                                            v-model="user.senha"
                                            @click:append="showAppendSenha = !showAppendSenha"
                                            @keydown.enter="doLogin()"
                                    ></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        @click="doLogin()"
                                        :loading="loading"
                                        :dark="valid"
                                        :disabled="!valid"
                                        color="#004d40"
                                >Login
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <v-snackbar v-model="snackbar" color="error" :top="true" :right="true">
            Usuário ou senha invalidos!
            <v-btn dark text @click="snackbar=false">
                <v-icon>mdi-clear</v-icon>
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>
    export default {
        props: {
            source: String
        },
        data: () => {
            return {
                loading: false,
                valid: null,
                showAppendSenha: false,
                user: {
                    login: null,
                    senha: null,
                    timeInSeconds: 604800
                },
                snackbar: false
            };
        },
        methods: {
            doLogin() {
                if (!this.valid) return;
                this.loading = true;
                this.$store
                    .dispatch("Login/login", this.user)
                    .then(() => {
                        return this.$router.push("/");
                    })
                    .catch(() => {
                        this.snackbar = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    };
</script>
